import React from "react";
import useHover from "../hooks/useHover";
import ObjectIdHolder from "../misc/elements/ObjectIdHolder";

const RelatedView = ({
  array,
  name,
  type,
  width = "80%",
  flex = 1,
  onClick,
}) => {
  const hover = useHover();
  return (
    <div
      {...hover.divProps}
      className="divColumn"
      style={{ width: "100%", flex, height: "100%" }}
    >
      <div className="divColumn" style={{ width, flex, position: "relative" }}>
        <div
          style={{
            position: "absolute",
            backgroundColor: "#9f9f9f",
            width: "100%",
            height: "100%",
            padding: "5px",
            borderRadius: ".5rem/.5rem",
            opacity: 0.5,
            border: "3px solid #bfbfbf",
          }}
        />
        <div
          className="textBoldWhite"
          style={{ zIndex: 1, padding: "5px", color: "#2f2f2f" }}
        >
          {name}
        </div>
        <div
          className="divColumn"
          style={{
            flex: 1,
            justifyContent: array?.length == 0 ? "center" : null,
          }}
        >
          {array?.length > 0 ? (
            array.map((id, index) => (
              <ObjectIdHolder
                objectId={id}
                onClick={onClick}
                type={type}
                key={index}
              />
            ))
          ) : onClick ? (
            <AddNew type={type} hover={hover} />
          ) : (
            <NoneFound />
          )}
        </div>
      </div>
    </div>
  );
};

const AddNew = ({ type, hover }) => {
  return (
    <div
      className="textBold"
      style={{
        cursor: "pointer",
        color: hover.hover ? "gold" : "#2f5f2f",
        fontSize: "25px",
        zIndex: 1,
      }}
    >
      {`Add New ${type} `}
    </div>
  );
};

const NoneFound = () => {
  return (
    <div
      className="textBold"
      style={{ color: "#5f5f5f", fontSize: "25px", zIndex: 1 }}
    >
      None Found
    </div>
  );
};

export default RelatedView;
